import moment from 'moment';
import { LOCAL_ID_PREFIX } from '../constants';

export const today = moment(new Date());

export const randomString = (length: number): string => {
    const CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) result += CHARS[Math.floor(Math.random() * CHARS.length)];
    return result;
};

// returns age in years (age) and months (month)
export const calculateAge = (dob: string): { age: string; month: string } => {
    const date = moment(dob);
    const ageInt = today.diff(date, 'years');
    const age = (isNaN(ageInt) ? '' : ageInt).toString();
    const monthAgeInt = today.diff(date, 'month') % 12;
    const month = (isNaN(monthAgeInt) ? '' : monthAgeInt).toString();

    return { age, month };
};

export const toTitleCase = (str: string): string => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const SINGULARS: { [k: string]: string } = {
    days: 'Day',
    day: 'Day',
    weeks: 'Week',
    week: 'Week',
    months: 'Month',
    month: 'Month',
    years: 'Year',
    year: 'Year',
    yr: 'yr',
    yrs: 'yr',
    mth: 'mth',
    mths: 'mth',
    min: 'min',
    mins: 'min',
    exception: 'Exception',
    exceptions: 'Exception',
};

const PURALS: { [k: string]: string } = {
    days: 'Days',
    day: 'Days',
    weeks: 'Weeks',
    week: 'Weeks',
    months: 'Months',
    month: 'Months',
    years: 'Years',
    year: 'Years',
    yr: 'yrs',
    yrs: 'yrs',
    mth: 'mths',
    mths: 'mths',
    min: 'mins',
    mins: 'mins',
    exception: 'Exceptions',
    exceptions: 'Exceptions',
};

export const getUnit = (selected: string, value: string): string => {
    const qt = parseInt(value);
    if (isNaN(qt)) {
        return selected;
    }
    const ce =
        qt === 1
            ? SINGULARS[selected.toLowerCase()] || selected
            : PURALS[selected.toLowerCase()] || selected;
    return ce;
};

export const getAgeString = (
    a: { age?: string; month?: string; dob?: string },
    prefix?: string,
    suffix?: string,
): string => {
    let aa, am;

    if (a.dob) {
        const temp = calculateAge(a.dob);
        aa = temp.age;
        am = temp.month;
    } else {
        aa = a.age;
        am = a.month;
    }

    const ageInt = parseInt(aa || '0');
    const ageMonthInt = parseInt(am || '0');

    if (isNaN(ageInt) && isNaN(ageMonthInt)) {
        return '';
    }

    if (aa && am && ageInt > 0 && ageMonthInt > 0) {
        return `${prefix || ''}${aa} ${getUnit('yrs', aa)}, ${am} ${getUnit('mth', am)}${
            suffix || ''
        }`;
    } else if (aa && ageInt > 0) {
        return `${prefix || ''}${aa} ${getUnit('yrs', aa)}${suffix || ''}`;
    } else if (am && ageMonthInt > 0) {
        if (ageMonthInt > 11) {
            return getAgeString(
                { age: `${ageMonthInt / 12}`, month: `${ageMonthInt % 12}` },
                prefix,
                suffix,
            );
        }
        return `${prefix || ''}${am} ${getUnit('mth', am)}${suffix || ''}`;
    }

    return '';
};

export const generateLocalId = (): string =>
    `${LOCAL_ID_PREFIX}${new Date().getTime()}-${randomString(4)}`;

export const generateRandomNumber = (min: number, max: number): number =>
    min + Math.floor(Math.random() * max);

export const getAgeInMonths = (a: { value?: string; month?: string }): number | undefined => {
    const ageInt = parseInt(a.value || '0');
    const ageMonthInt = parseInt(a.month || '0');

    if (isNaN(ageInt) || isNaN(ageMonthInt)) {
        return;
    }

    if (a.value && a.month && ageInt > 0 && ageMonthInt > 0) {
        return ageInt * 12 + ageMonthInt;
    } else if (a.value && ageInt > 0) {
        return ageInt * 12;
    } else if (a.month && ageMonthInt > 0) {
        return ageMonthInt;
    }

    return;
};

export const smoothScrollToItemWithDelay = (id: string, delay: number = 200): void => {
    setTimeout(() => {
        const myContainer = document.getElementById(id) as HTMLDivElement;
        if (myContainer) {
            myContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    }, delay);
};
